<template>
    <div class="container">
        <div class="alert alert-info">
            Laukelis "su PVM" - įrašius reikiamą suma su PVM spausti Enter
        </div>
        <div class="card">
            <div class="card-header">
                Naujas pasiūlymas
            </div>
            <div class="card-body">
                <div class="form-row">
                    <div class="col-12 col-md-6">
                        <label for="eq_id">Įranga</label>
                        <!--<select class="form-control" id="eq_id" v-model="new_equipment">-->
                            <!--<option v-for="e in equipment" :value="{id:e.id, text:e.name, price:e.price, power:e.power, equipment_type_id: e.equipment_type_id}">{{ e.type.name }} {{ e.name }} ({{ e.warranty }})</option>-->
                        <!--</select>-->
                        <v-select  v-if="equipment" class="vue-select2s" id="eq_id" name="select2"
                                   :options="equipment" label="long_name"
                                   :model.sync="new_equipment"
                                   v-model="new_equipment"
                                   :searchable="true" language="en-US">
                        </v-select>

                    </div>
                    <div class="col-6 col-md-3">
                        <label for="eq_qty">Kiekis</label>
                        <input id="eq_qty" class="form-control" @keyup="enter_submit" v-model="new_equipment_qty" type="text">
                    </div>
                    <div class="col-6 col-md-3">
                        <label for="">&nbsp;</label>
                        <button @click="add_equipment_to_offer" class="form-control btn btn-outline-success">Pridėti</button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="form-row" v-for="(se, i) in selected_equipment">
                    <div @click="deleteSelected(i, se.price, se.quantity)" class="col-1">-</div>
                    <div class="col-11 col-md-6">{{ se.equipment_text }} -- {{ se.quantity }} vnt.</div>
                </div>

                <div class="form-row">
                    <div class="col-6 col-lg-2">
                        <div class="form-group">
                            <label for="price">Kaina</label>
                            <div class="input-group">
                                <input id="price" class="form-control" type="text" v-model="price">
                                <div class="input-group-append">
                                    <div class="input-group-text">€</div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-6 col-lg-2">
                        <div class="form-group">
                            <label for="price">su PVM</label>
                            <div class="input-group">
                                <input id="_with_vat"  class="form-control" @keyup="to_no_vat" @dblclick="to_no_vat_dbl" type="text" :value='(this.price * 1.21).toFixed(2)'>
                                <div class="input-group-append">
                                    <div class="input-group-text">€</div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-6 col-lg-2">
                        <div class="form-group">
                            <label for="discount">Nuolaida {{ this.discount }}</label>
                            <div class="input-group">
                                <!--<input id="discount" @mouseout="" class="form-control" type="text" v-model="discount">-->
                                <input id="discount" class="form-control" type="text" @keyup="calc_discount" @mouseover="set_discount">
                                <div class="input-group-append">
                                    <div class="input-group-text">€</div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-6 col-lg-2">
                        <div class="form-group">
                            <label for="price">po su Pvm</label>
                            <div class="input-group">
                                <input id="vat" class="form-control" type="text" readonly :value='((this.price - this.discount)* 1.21).toFixed(2)'>
                                <div class="input-group-append">
                                    <div class="input-group-text">€</div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-6 col-lg-2">
                        <div class="form-group">
                            <label for="discount">Galia</label>
                            <div class="input-group">
                                <input id="power" class="form-control" type="text" v-model="power">
                                <div class="input-group-append">
                                    <div class="input-group-text">kW</div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-6 col-lg-2">
                        <div class="form-group">
                            <label for="discount">Suvartojimas</label>
                            <div class="input-group">
                                <input id="usage" class="form-control" type="text" v-model="usage">
                                <div class="input-group-append">
                                    <div class="input-group-text">kW</div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label for="discount">Avansas
                                {{ this.payment1 }}
                            </label>
                            <div class="input-group">
                                <input id="percent1" class="form-control" type="text" v-model="percent1">
                                <div class="input-group-append">
                                    <div class="input-group-text">%</div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label for="discount">Mokėjimas
                                {{ this.payment2 }}</label>
                            <div class="input-group">
                                <input id="percent2" readonly class="form-control" type="text">
                                <div class="input-group-append">
                                    <div class="input-group-text">%</div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label for="discount">Atsiskaitymas
                                {{ this.payment3 }}</label>
                            <div class="input-group">
                                <input id="percent3" class="form-control" type="text" v-model="percent3">
                                <div class="input-group-append">
                                    <div class="input-group-text">%</div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
            <div class="card-footer">
                <button @click="store_offer" :disabled='store_disabled' class="btn btn-outline-success">Sukurti</button>
            </div>
        </div>
    </div>
</template>

<script>
    import vSelect from 'vue-select';
    export default {
        name: "NewOffer",
        props:['cid', 'uid'],
        components:{
            vSelect,
        },
        data() {
            return {
                customer_id: '',
                power:'',
                price: '',
                discount: 0,
                payment1: '',
                percent1: '',
                payment2: '',
                percent2: '',
                payment3: '',
                percent3: '',
                equipment: '',
                usage: '',
                new_equipment: '',
                new_equipment_qty: '',
                selected_equipment: [],
                total:'',
                user_id:'',
                store_disabled: false
            }
        },
        watch: {
            percent1: function (val) {
                this.payment1 = Math.round((((this.price *1.21 - this.discount * 1.21) / 100) * val) / 100) * 100;
                this.percent3 = this.payment3 = 0;
                if (this.percent1){
                    this.payment2 = ((this.price *1.21 - this.discount *1.21) - (this.payment1 + this.payment3)).toFixed(2);
                    this.percent2 = 100 - this.percent1 - this.percent3;
                    if(this.payment2 < 0){
                        this.payment1 += this.payment2;
                        this.payment2 = 0;
                    }
                }
                if(this.percent1 == 100){
                    this.payment2 = 0;
                    this.percent2 = 0;
                    this.payment3 = 0;
                    this.percent3 = 0;
                }
            },

            percent3: function (val) {
                this.payment3 = Math.round((((this.price *1.21 - this.discount * 1.21) / 100) * val) / 100) * 100;
                if (this.percent1 && this.percent3) {
                    this.payment2 = ((parseFloat(this.price) *1.21 - parseFloat(this.discount) * 1.21) - (parseFloat(this.payment1) + parseFloat(this.payment3))).toFixed(2);
                    this.percent2 = 100 - this.percent1 - this.percent3;
                    if(this.payment2 < 0){
                        this.payment3 += parseFloat(this.payment2);
                        this.payment2 = 0;
                    }
                }

                if(this.percent3 == 100){
                    this.payment3 = (this.price * 1.21 - this.discount * 1.21).toFixed(2);
                    this.payment2 = 0;
                    this.percent2 = 0;
                    this.payment1 = 0;
                    this.percent1 = 0;
                }

            },
            price: function (val) {
                if (val > 999) {
                    this.percent1 = this.percent3 = 0;
                    if (this.payment1) {
                        this.payment1 = Math.round((( (val - this.discount) / 100) * this.percent1()) / 100) * 100;
                        this.payment1 = (this.payment1 * 1.21).toFixed(2);
                    }
                    if (this.payment3) {
                        this.payment3 = Math.round(((val / 100) * this.percent3()) / 100) * 100;
                        this.payment3 = (this.payment3 * 1.21).toFixed(2);
                    }
                    if (this.percent1 && this.percent3) {
                        this.payment2 = this.price - (this.payment1 + this.payment3);
                        this.payment2 = (this.payment2 * 1.21).toFixed(2);
                    }
                }

            },
            discount: function(){
                this.percent1 = this.percent3 = '';
            }
        },
        mounted() {

            axios.get('/get_equipment').then(res => {
                this.equipment = res.data
            });


        },
        created(){

        },
        methods: {
            add_equipment_to_offer() {
                this.selected_equipment.push({equipment_id:this.new_equipment.id, equipment_text:this.new_equipment.name, quantity: this.new_equipment_qty, price: this.new_equipment.price});
                this.price = (Number(this.price) + ( Number(this.new_equipment.price) *  Number(this.new_equipment_qty) )).toFixed(2);
                this.percent1 = this.percent3 = '';
                console.log(this.new_equipment.power);
                if(this.new_equipment.power > 0 && (this.new_equipment.equipment_type_id == 1 || this.new_equipment.name.indexOf('įkrovimo stotelė') > -1)){
                    this.power = Number(this.power) + Number(this.new_equipment.power) * Number(this.new_equipment_qty);
                    this.power  = this.power.toFixed(2);
                }
                this.new_equipment_qty = '';
            },
            deleteSelected(i, price, quantity){
                this.selected_equipment.splice(i, 1);
                this.price = Number(this.price) - ( Number(price) *  Number(quantity) );
            },
            store_offer(){
                this.store_disabled = true;
                console.log(this._data);

                if (this.percent1 < 1 && this.percent3 != 100) {
                    $('#percent1').addClass('is-invalid');
                    this.store_disabled = false;
                    return;
                }
                if (this.percent3 < 1 && (100 - this.percent1 - this.percent2) != 0) {
                    $('#percent3').addClass('is-invalid');
                    this.store_disabled = false;
                    return;
                }
                if (this.price < 1) {
                    $('#price').addClass('is-invalid');
                    this.store_disabled = false;
                    return;
                }


               this.total = Number(this.price) - Number(this.discount);
               this.customer_id = this.$props.cid;
               this.user_id = this.$props.uid;
               this.percent2 = (100 - this.percent1 - this.percent3);
               axios.post('/store_offer', this._data).then(res => {
                   window.location.replace('/customer/'+this.$props.cid)
               }).catch(error => {
                  let array =  {'msg': error.response.data.message};
                   axios.post('/mail_error', array).then(res =>{
                       console.log(res.data);
                   });
                   window.location.replace('/404');
               });
            },

            calc_discount(e){
                console.log($(e.target).val());
                this.discount = ($(e.target).val() / 1.21).toFixed(4);
            },

            set_discount(e){
                $(e.target).val((this.discount * 1.21).toFixed(2));
            },

            delete_comma(e){
                $(e.target).val($(e.target).val().replace(',','.'));
            },

            to_no_vat(e){
                if(e.keyCode == 13){
                    this.price = (e.target.value / 1.21).toFixed(4);
                }
            },
            to_no_vat_dbl(e){
                    this.price = (e.target.value / 1.21).toFixed(4);
            },

            enter_submit(e){
                if(e.keyCode == 13){
                    console.log('enter');
                    this.add_equipment_to_offer();
                }

            }
        }
    }
</script>

<style scoped>

</style>
